/**
 * 成果类型
 */
export const achievementTypeData =  [
  {
    id: 0,
    name: "中文期刊",
    count: 0,
    countPer: 0,
    color: "#2c5dfe",
    data: [1],
    language: 'zh'
  },
  {
    id: 1,
    name: "外文期刊",
    count: 0,
    countPer: 0,
    color: "#409EFF",
    data: [1],
    language: 'en'
  },
  {
    id: 2,
    name: "学位论文",
    count: 0,
    countPer: 0,
    color: "#e6a23c",
    data: [2],
    language: ''
  },
  {
    id: 3,
    name: "会议论文",
    count: 0,
    countPer: 0,
    color: "#f56c6c",
    data: [3],
    language: ''
  },
  {
    id: 4,
    name: "视频课程",
    count: 0,
    countPer: 0,
    color: "#606266",
    data: [25],
    language: ''
  },
  {
    id: 5,
    name: "教案课件",
    count: 0,
    countPer: 0,
    color: "#67c23a",
    data: [27],
    language: ''
  },
  {
    id: 6,
    name: "露禾文库",
    count: 0,
    countPer: 0,
    color: "#26cdb9",
    data: [38],
    language: ''
  }
]
/* 重庆区县 */
export const chonqgingAreaData = [
  {
      "label": "万州区",
      "value": "万州区"
  },
  {
      "label": "涪陵区",
      "value": "涪陵区"
  },
  {
      "label": "渝中区",
      "value": "渝中区"
  },
  {
      "label": "大渡口区",
      "value": "大渡口区"
  },
  {
      "label": "江北区",
      "value": "江北区"
  },
  {
      "label": "沙坪坝区",
      "value": "沙坪坝区"
  },
  {
      "label": "九龙坡区",
      "value": "九龙坡区"
  },
  {
      "label": "南岸区",
      "value": "南岸区"
  },
  {
      "label": "北碚区",
      "value": "北碚区"
  },
  {
      "label": "綦江区",
      "value": "綦江区"
  },
  {
      "label": "大足区",
      "value": "大足区"
  },
  {
      "label": "渝北区",
      "value": "渝北区"
  },
  {
      "label": "巴南区",
      "value": "巴南区"
  },
  {
      "label": "黔江区",
      "value": "黔江区"
  },
  {
      "label": "长寿区",
      "value": "长寿区"
  },
  {
      "label": "江津区",
      "value": "江津区"
  },
  {
      "label": "合川区",
      "value": "合川区"
  },
  {
      "label": "永川区",
      "value": "永川区"
  },
  {
      "label": "南川区",
      "value": "南川区"
  },
  {
      "label": "璧山区",
      "value": "璧山区"
  },
  {
      "label": "铜梁区",
      "value": "铜梁区"
  },
  {
      "label": "潼南区",
      "value": "潼南区"
  },
  {
      "label": "荣昌区",
      "value": "荣昌区"
  },
  {
      "label": "梁平县",
      "value": "梁平县"
  },
  {
      "label": "城口县",
      "value": "城口县"
  },
  {
      "label": "丰都县",
      "value": "丰都县"
  },
  {
      "label": "垫江县",
      "value": "垫江县"
  },
  {
      "label": "武隆县",
      "value": "武隆县"
  },
  {
      "label": "忠县",
      "value": "忠县"
  },
  {
      "label": "云阳县",
      "value": "云阳县"
  },
  {
      "label": "奉节县",
      "value": "奉节县"
  },
  {
      "label": "巫山县",
      "value": "巫山县"
  },
  {
      "label": "巫溪县",
      "value": "巫溪县"
  },
  {
      "label": "石柱土家族自治县",
      "value": "石柱土家族自治县"
  },
  {
      "label": "秀山土家族苗族自治县",
      "value": "秀山土家族苗族自治县"
  },
  {
      "label": "酉阳土家族苗族自治县",
      "value": "酉阳土家族苗族自治县"
  },
  {
      "label": "彭水苗族土家族自治县",
      "value": "彭水苗族土家族自治县"
  },
  {
      "label": "开州区",
      "value": "开州区"
  },
  {
    "label": "两江新区",
    "value": "两江新区"
},
{
    "label": "高新技术产业开发区",
    "value": "高新技术产业开发区"
},
{
    "label": "经济技术开发区",
    "value": "经济技术开发区"
},
{
    "label": "万盛经济技术开发区",
    "value": "万盛经济技术开发区"
},
]

/* 课题申报 */
/* 课题类型 */
export const applicationTopicTypeData = [
  {
    value: 1,
    label: '重点项目'
  },
  {
    value: 2,
    label: '一般项目'
  },
  {
    value: 3,
    label: '青年项目'
  },   
]
/* 成果完成情况 */
export const applicationCompletionData = ["研究报告","研究论文","专善或译著","资政报告","软件","工具书","其他"]
/* 审核状态 */
export const applicationIsAuditData = [
  {
    value: 0,
    label: "待审核"
  },
  {
    value: 1,
    label: "资料申请通过"
  },
  {
    value: 2,
    label: "资料申请未通过"
  },
  {
    value: 3,
    label: "立项申请通过"
  },
  {
    value: 4,
    label: "立项申请未通过"
  },
  {
    value: 5,
    label: "提交结项申请"
  },
  {
    value: 6,
    label: "结项审核不通过"
  },
  {
    value: 7,
    label: "结项审核通过"
  },

]

export const commonData = {
  achievementTypeData,
  chonqgingAreaData,
  applicationTopicTypeData,
  applicationCompletionData,
};

export const MemberTypeList = Object.create([{label: "",value: 0},{label: "基础会员",value: 1},{label: "一般会员",value: 2},{label: "旗舰会员",value: 3},{label: "基础会员升级一般会员",value: 4},{label: "基础会员升旗舰会员",value: 5},{label: "一般会员升旗舰会员",value: 5}])

export const OrgList = Object.create([
    {label: "全部", value: -1},
    {label: "否", value: 0},
    {label: "是", value: 1},
])
export const WhatByList = Object.create([
    {label: "全部", value: -1},
    {label: "订单生成", value: 0},
    {label: "机构生成", value: 1},
])
export const DeleteFlagList = Object.create([
    {label: "全部", value: -1},
    {label: "有效", value: 0},
    {label: "无效", value: 1},
    {label: "升级失败", value: 2},
])

export const DiscountType = Object.create(["报刊订阅","线下教研大会","年度分析报告","“好老师智库”会员","“好老师智库”专访宣介","维普查重检测（职称版）","大家·数字出版体验券（8折）","大家·数字出版体验券（6折）","投稿分析","选题分析","维普查重检测（机构版）","电子刊专用检测报告"])
export const DiscountTypeRemark = Object.create([
    "课堂内外杂志社出品的精品报刊任选",
    "有机会受邀参加线下教研大会等学术活动",
    "年度分析报告",
    "受聘“好老师智库”会员，参与智库新书试读等活动",
    "“好老师智库”专区个人风采展示，有机会获得微信公众号“好老师智库”、纸刊《课堂内外》（中国好老师）宣介",
    "维普论文检测系统",
    "大家•维普期刊OA出版平合",
    "大家•维普期刊OA出版平合",
    "学术期刊投稿分析系统",
    "“全景式”了解主题相关科研现状",
    "维普论文检测系统",
    "大家•維普期刊OA出版平合"
])

export const PayStatusList = Object.create([{value: 0, label: "未支付"}, {value: 1, label: "已支付"}])

export const TransactionType = Object.create([{value: 0, label: "支付宝支付"}, {value: 1, label: "微信支付"}])

export const imgPath = 'https://s3.cn-northwest-1.amazonaws.com.cn/pub.s3.cqvip.com/'

export const IsUseList = Object.create([
    {label: "可使用", value: 0},
    {label: "已使用", value: 1},
    {label: "已过期", value: 2},
])

export const SpecialTeacher = Object.create(["特约记者","特约讲师","特约作者","特约研修员"])
export const SpecialTeacherList = [
    {id: 1,label: "特约记者",background: "以教师视角记录身边的教育故事，撰写报道，见证教育发展",isSubmit: true,condition:"申请条件：<br/>" +
            "1.学校宣传、党办等部门相关教育工作者优先；<br/>" +
            "2.热爱教育事业，留心观察、学习身边榜样教师；<br/>" +
            "3.每年至少完成2篇相关稿件。<br/>",equity:"相关权益：<br/>" +
            "1.特约记者的相关稿件将由智库优先推荐并发表于《课堂内外》（中国好老师）杂志，并获取相应稿酬。<br/>" +
            "2.特约记者将获得由课堂内外以及好老师智库联合颁发的“特约记者”证书。"},
    {id: 2,label: "特约讲师",background: "开办公益讲堂，分享教育经验，启迪教育智慧",isSubmit: false,condition:"申请条件：<br/>" +
            "1.表达流畅，有信息化使用基础或愿意学习相关操作；<br/>" +
            "2.每年至少开展1次线上公益讲座；<br/>" +
            "3.每年至少完成2篇相关稿件。",equity:"相关权益：<br/>" +
            "1.智库将为特约讲师搭建个人专属分享专区，协助讲师开展直播讲座，并通过好老师智库系列途径立体化宣传直播，扩大好老师影响力。参与公益讲堂的讲师将获得由课堂内外以及好老师智库颁发的“特约讲师”证书及定制礼品。<br/>" +
            "2.表现突出的讲师将被授予“特约讲师”称号，由智库推荐参与“好老师成长与发展千人大会”系列主题式论坛等更多线下讲座、论坛，并获得相应报酬。"},
    {id: 3,label: "特约作者",background: "参与智库投稿，让好老师的理念与方法被更多人看见",isSubmit: true,condition:"申请条件：<br/>" +
            "1.擅长教育写作，有相关代表作品；<br/>" +
            "2.每年至少完成2篇相关稿件或参与2次圆桌主题策划等活动。",equity:"相关权益：<br/>" +
            "1.特约作者按栏目要求投稿，将由智库优先遴选发表于《课堂内外》（中国好老师）杂志和好老师智库微信公众平台，并根据撰稿内容为教师支付一定稿酬。<br/>" +
            "2.智库特约作者将获得由课堂内外以及好老师智库颁发的“特约作者”证书，智库将根据作品内容、质量与阅读量等综合指标，每年推选智库年度十佳作者，并获得智库平台个人专栏开设权益。<br/>" +
            "3.智库特约作者将获得课堂内外杂志社、智库出品等新书试读权益，让阅读体验领先一步。"},
    {id: 4,label: "特约研修员",background: "协助智库开展教育教研活动，聚力同行，研思共进",isSubmit: true,condition:"申请条件：<br/>" +
            "1.热爱教育科研、教研工作，承担过区、市、省级课题项目的老师优先；<br/>" +
            "2.有个人的具体研究方向并已沉淀相关经验、成果。",equity:"相关权益：<br/>" +
            "1.协助智库活动开展的特约研修员，将会获得由《课堂内外》以及好老师智库颁发的“特约研修员”证书及定制礼物。<br/>" +
            "2.表现突出的智库特约研修员，将有机会参与“寻找中国好老师”公益行动大众评审、青年教师教研成果展示交流活动评审等活动重要环节并获得相应评审费用。"}
]

export const SpecialType = {
    "特约记者": 1,
    "特约讲师": 2,
    "特约作者": 3,
    "特约研修员": 4,
}